import { DateTime } from "luxon";

const dateTimeTransformer = {
  from: (iso: string): DateTime => DateTime.fromISO(iso),
  to: (dateTime: DateTime): string => dateTime.toISO(),
};

export default dateTimeTransformer;